<template>
    <div>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
        <v-data-table :headers="headers" :items="items" :search="search" :single-expand="false" :expanded.sync="expanded" item-key="id" show-expand>
            <template v-slot:item.actions="{ item }">
                <!-- <v-menu bottom left>
                    <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>

                    <v-list>
                      
                        <v-list-item
                            @click="
                                selectedItem = item
                                newcredits = item.credits
                                changeCreditsDialog = true
                            "
                        >
                            <v-list-item-title>change credits</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            @click="
                                selectedItem = item
                                newstartdate = item.startdate.split('T')[0]
                                changeStartDateDialog = true
                            "
                        >
                            <v-list-item-title>change startdate</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu> -->
                <!-- Change Group Dialog -->
                <!-- <v-dialog v-model="changeCreditsDialog" max-width="400" height="300px">
                    <v-card>
                        <v-card-title> Company: {{ selectedItem ? selectedItem.company_id : "" }} </v-card-title>
                        <v-card-subtitle>
                            Change Credits
                        </v-card-subtitle>

                        <v-card-text>
                            <v-text-field color="primary" v-model="newcredits" type="number"> </v-text-field>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn rounded class="mx-auto" color="primary" dark @click="changeCredits"> Change Credits </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog> -->

                <!-- Change StartDate Dialog -->
                <!-- <v-dialog v-model="changeStartDateDialog" max-width="400" height="300px">
                    <v-card>
                        <v-card-title> Company: {{ selectedItem ? selectedItem.company_id : "" }} </v-card-title>
                        <v-card-subtitle>
                            Change Credits
                        </v-card-subtitle>

                        <v-card-text>
                            <v-text-field color="primary" v-model="newstartdate" type="date"> </v-text-field>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn rounded class="mx-auto" color="primary" dark @click="changeStartDate"> Change Start Date </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog> -->

                <!-- <v-dialog
          v-model="item.text"
          max-width="500px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              x-small
              fab
              v-bind="attrs"
              v-on="on"
            >
              <v-icon
                small
                color="primary"
              >
                mdi-pencil
              </v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">Edit Company </span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-text-field
                      v-model="editedItem.name"
                      label="Dessert name"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-text-field
                      v-model="editedItem.calories"
                      label="Calories"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-text-field
                      v-model="editedItem.fat"
                      label="Fat (g)"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-text-field
                      v-model="editedItem.carbs"
                      label="Carbs (g)"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-text-field
                      v-model="editedItem.protein"
                      label="Protein (g)"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="item.text = false"
              >
                Cancel
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="editItem(item)"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog> -->
            </template>
            <template v-slot:expanded-item="{ headers, item }">
                <!-- <td :colspan="headers.length">
                    Requests Overall: {{ item.requestCount > 0 ? item.requestCount : 0 }}
                    <br />
                    Update requests overall: {{ item.requestsUpdates > 0 ? item.requestsUpdates : 0 }}
                    <br />
                    Requests in last 30 days: {{ item.requestsCounts30Days > 0 ? item.requestsCounts30Days : 0 }}
                    <br />
                    Update requests in last 30 days: {{ item.requestsUpdates30Days > 0 ? item.requestsUpdates30Days : 0 }}
                </td> -->
            </template>
        </v-data-table>
    </div>
</template>
<script>
    export default {
        data: () => ({
            /**********************************************************
             * Overview of Companies Datatable:
             **********************************************************/
            auth: "Basic " + window.btoa(process.env.VUE_APP_AUTH),
            editDialog: false,
            editedItem: {
                name: "",
                calories: 0,
                fat: 0,
                carbs: 0,
                protein: 0
            },
            expanded: [],
            singleExpand: false,

            search: "",
            headers: [
                { text: "ID", filterable: true, sortable: true, value: "id" },
                { text: "Company ID", filterable: true, sortable: true, value: "company_id" },
                { text: "Name", filterable: true, sortable: true, value: "name" },
                { text: "User", filterable: false, sortable: true, value: "user_id" },
                { text: "Date", filterable: false, sortable: true, value: "date" },
                { text: "Campaign", filterable: false, sortable: true, value: "campaign" },

                // { text: "Actions", filterable: false, sortable: false, value: "actions" },
                { text: "", value: "data-table-expand" }
            ],
            items: [],
            selectedItem: {},

            //change credits dialog
            changeCreditsDialog: false,
            newcredits: 0,

            //change startdate dialog
            newstartdate: new Date(),
            changeStartDateDialog: false
        }),
        methods: {
            changeCredits() {
                this.$http
                    .post(
                        process.env.VUE_APP_APIURL + "/admin/monitoring/credits/set",
                        { credits: this.newcredits, company_id: this.selectedItem.company_id },
                        { headers: { Authorization: this.auth } }
                    )
                    .then((response) => {
                        console.log(response.body)
                        this.fetchCredits()
                        this.changeCreditsDialog = false
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },
            changeStartDate() {
                this.$http
                    .post(
                        process.env.VUE_APP_APIURL + "/admin/monitoring/credits/set/startdate",
                        { new_startdate: this.newstartdate, company_id: this.selectedItem.company_id },
                        { headers: { Authorization: this.auth } }
                    )
                    .then((response) => {
                        console.log(response.body)
                        this.fetchCredits()
                        this.changeStartDateDialog = false
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },
            fetchRegs: function() {
                this.$http
                    .get(process.env.VUE_APP_APIURL + "/admin/monitoring/registrations", { headers: { Authorization: this.auth } })
                    .then((response) => {
                        console.log(response.body)
                        this.items = response.body.data
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }
        },
        mounted() {
            this.fetchRegs()
        }
    }
</script>
